import React from 'react'
import { FileStyles } from './styles'

import { FileInterface } from '..'
import { formatFileSize } from '../../../../utils/utils'
import { LoaderComponent } from '../../../Button/styles'
import { FaCheck, FaCircleExclamation, FaEye, FaFolder, FaTrash, FaXmark } from 'react-icons/fa6'
import { ButtonRound } from '../../../Header/styles'
import { useTheme } from 'styled-components'
import { ButtonIcon } from '../../../Table/Pagination/styles'

export interface FileUploadHandle {
  setProgress: (progress: number) => void
  setStarted: (progress: number) => void
  setUploadedId: (_id: string) => void
  setIsloading: (loading: boolean) => void
  setError: () => void
  isStarted: boolean
  doneUpload: boolean
}
export interface FileUploadProps {
  item: FileInterface
  onRemove: (index: number) => void
  onShow: (_id: string) => void
  onDelete: (_id: string, index: number) => void
  index: number
  socketObj: any
}

const FileUpload: React.ForwardRefRenderFunction<FileUploadHandle, FileUploadProps> = (
  { item, onRemove, onShow, onDelete, index, socketObj },
  ref,
) => {
  const [progress, setProgress] = React.useState(0)

  const theme: any = useTheme()

  const [socketId, setSocketId] = React.useState<string>()
  const [isStarted, setIsStarted] = React.useState(false)
  const [doneUpload, setDoneUpload] = React.useState(false)
  const [uploadedId, setUploadedId] = React.useState<string | undefined>()
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState(false)

  React.useImperativeHandle(
    ref,
    () => ({
      setProgress(progress: number) {
        setProgress(progress)
      },
      setSocketId(_id: string) {
        setSocketId(_id)
        this.setStarted()
        socketObj.on(_id, (data: any) => {
          if (typeof data.progress !== 'undefined') {
            setProgress(data.progress)
          }
          if (data.error) {
            this.setError()
          }
          if (data.finished) {
            this.setUploadedId(_id)
          }
        })
      },
      setSocket(_id: string) {
        socketObj.removeListener(_id)
      },
      setStarted() {
        setError(false)
        setProgress(0)
        setDoneUpload(false)
        setIsStarted(true)
        //this.setIsloading(true)
      },
      setUploadedId(_id: string) {
        setUploadedId(_id)
        setDoneUpload(true)
      },
      setIsloading(loading: boolean) {
        setLoading(loading)
      },
      setError() {
        setProgress(0)
        setError(true)
        setDoneUpload(false)
        setIsStarted(false)
      },
      isStarted: isStarted,
      doneUpload: doneUpload,
      socketId: socketId,
    }),
    [isStarted, doneUpload, socketId, socketObj],
  )

  return (
    <FileStyles.Container>
      <FileStyles.Content>
        <FaFolder size={35} />
        <FileStyles.Row style={{ justifyContent: 'space-between', width: '100%' }}>
          <FileStyles.Column>
            <FileStyles.Name>{item.name}</FileStyles.Name>
            <FileStyles.Size>{formatFileSize(item.size)}</FileStyles.Size>
          </FileStyles.Column>
          {loading ? (
            <>
              <LoaderComponent />
            </>
          ) : (
            <FileStyles.Row>
              {progress === 100 ? (
                <>
                  {error ? (
                    <>
                      <FaCircleExclamation color={theme.colors.error} size={20} />
                    </>
                  ) : (
                    <>
                      {uploadedId && (
                        <>
                          <ButtonRound
                            style={{
                              width: 20,
                              height: 20,
                              minWidth: 20,
                              minHeight: 20,
                              backgroundColor: theme.colors.success,
                            }}
                          >
                            <FaCheck color='white' size={15} />
                          </ButtonRound>
                          <ButtonIcon onClick={() => uploadedId && onShow(uploadedId)}>
                            <FaEye size={20} />
                          </ButtonIcon>
                          <ButtonIcon onClick={() => uploadedId && onDelete(uploadedId, index)}>
                            <FaTrash size={20} />
                          </ButtonIcon>
                        </>
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  {error && <FaCircleExclamation color={theme.colors.error} size={20} />}{' '}
                  {!isStarted && (
                    <ButtonRound onClick={() => onRemove(index)}>
                      <FaXmark color='white' size={15} />
                    </ButtonRound>
                  )}
                </>
              )}
            </FileStyles.Row>
          )}
        </FileStyles.Row>
      </FileStyles.Content>
      {!doneUpload && (
        <FileStyles.Progress>
          <FileStyles.ProgressContent />
          <FileStyles.ProgressBar progress={progress} />
        </FileStyles.Progress>
      )}
    </FileStyles.Container>
  )
}

export default React.forwardRef(FileUpload)
